// @core/api/endpoints/tenant/get_tenant_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TenantSettingsResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Get tenant settings
 * Retrieves the current tenant settings including privacy, notifications, and feature configurations. Requires admin privileges on the tenant.
 */
export async function GetTenantSettings(
  tenant_id: string,
  options?: RequestOptions
): Promise<TenantSettingsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/settings`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.get<TenantSettingsResponse>(requestPath, { ...requestOptions });
}
